export default [
    { value: "admin", label: "Админ" },
    { value: "provider", label: "Поставщик" },
    { value: "client", label: "Клиент" },
    { value: "courier", label: "Экспедитор" },
]